import http from "@/http"
import { Item } from "@/interfaces/library"

export async function getCartSample (): Promise<Item[]> {
  const { data } = await http.get(`/cart/sample`)
  return data
}